import {
    FETCH_FILTER_DATA_FOR_DASHBOARD_REQUEST_DK,
    FETCH_FILTER_DATA_FOR_DASHBOARD_SUCCESS_DK,
    FETCH_FILTER_DATA_FOR_DASHBOARD_FAILURE_DK,
    FETCH_SUPPLIER_WISE_DATA_FOR_DASHBOARD_REQUEST_DK,
    FETCH_SUPPLIER_WISE_DATA_FOR_DASHBOARD_SUCCESS_DK,
    FETCH_SUPPLIER_WISE_DATA_FOR_DASHBOARD_FAILURE_DK,
    FETCH_ITEM_WISE_DATA_FOR_DASHBOARD_REQUEST_DK,
    FETCH_ITEM_WISE_DATA_FOR_DASHBOARD_SUCCESS_DK,
    FETCH_ITEM_WISE_DATA_FOR_DASHBOARD_FAILURE_DK,
    FETCH_OUTSTANDING_WISE_DATA_FOR_DASHBOARD_REQUEST_DK,
    FETCH_OUTSTANDING_WISE_DATA_FOR_DASHBOARD_SUCCESS_DK,
    FETCH_OUTSTANDING_WISE_DATA_FOR_DASHBOARD_FAILURE_DK,
    FETCH_SUMMARY_DATA_FOR_DASHBOARD_REQUEST_DK,
    FETCH_SUMMARY_DATA_FOR_DASHBOARD_SUCCESS_DK,
    FETCH_SUMMARY_DATA_FOR_DASHBOARD_FAILURE_DK,
    FETCH_ALL_SUMMARY_DATA_FOR_DASHBOARD_REQUEST_DK,
    FETCH_ALL_SUMMARY_DATA_FOR_DASHBOARD_SUCCESS_DK,
    FETCH_ALL_SUMMARY_DATA_FOR_DASHBOARD_FAILURE_DK
} from './dashboard.actionType';

export const DASHBOARD_DK = 'dashboardDK';

let initialState = {
    loading: false,
    dashboardFilterList: [],
    dashboardSupplierWiseList: [],
    dashboardItemWiseList: [],
    dashboardOutstandingWiseList: [],
    dashboardSummaryWiseList: []
};

export let dashboardDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_FILTER_DATA_FOR_DASHBOARD_REQUEST_DK:
        case FETCH_SUPPLIER_WISE_DATA_FOR_DASHBOARD_REQUEST_DK:
        case FETCH_ITEM_WISE_DATA_FOR_DASHBOARD_REQUEST_DK:
        case FETCH_OUTSTANDING_WISE_DATA_FOR_DASHBOARD_REQUEST_DK:
        case FETCH_ALL_SUMMARY_DATA_FOR_DASHBOARD_REQUEST_DK:
        case FETCH_SUMMARY_DATA_FOR_DASHBOARD_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_FILTER_DATA_FOR_DASHBOARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dashboardFilterList: updatePayload
            };
        case FETCH_ALL_SUMMARY_DATA_FOR_DASHBOARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dashboardAllSummaryList: updatePayload
            };
        case FETCH_SUPPLIER_WISE_DATA_FOR_DASHBOARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dashboardSupplierWiseList: updatePayload
            };
        case FETCH_ITEM_WISE_DATA_FOR_DASHBOARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dashboardItemWiseList: updatePayload
            };
        case FETCH_SUMMARY_DATA_FOR_DASHBOARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dashboardSummaryWiseList: updatePayload
            };
        case FETCH_ITEM_WISE_DATA_FOR_DASHBOARD_FAILURE_DK:
            return {
                ...state,
                loading: false,
                dashboardItemWiseList: []
            }

        case FETCH_OUTSTANDING_WISE_DATA_FOR_DASHBOARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dashboardOutstandingWiseList: updatePayload
            };
        case FETCH_OUTSTANDING_WISE_DATA_FOR_DASHBOARD_FAILURE_DK:
            return {
                ...state,
                loading: false,
                dashboardOutstandingWiseList: []
            }
        case FETCH_SUPPLIER_WISE_DATA_FOR_DASHBOARD_FAILURE_DK:
            return {
                ...state,
                loading: false,
                dashboardSupplierWiseList: []
            }
        case FETCH_FILTER_DATA_FOR_DASHBOARD_FAILURE_DK:
        case FETCH_ALL_SUMMARY_DATA_FOR_DASHBOARD_FAILURE_DK:
        case FETCH_SUMMARY_DATA_FOR_DASHBOARD_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
